import { VTab, VTabTrigger, VTabTriggerContainer } from '../VTab';
import { useVPeriodSelectorContext } from './hook';
import type { PeriodUnit } from './type';

export const VPeriodUnit = () => {
  const { periodUnitList, periodUnitValue, onPeriodUnitChange } =
    useVPeriodSelectorContext();

  return (
    <VTab
      defaultValue={periodUnitValue}
      value={periodUnitValue}
      onValueChange={value => onPeriodUnitChange(value as PeriodUnit)}
      size="small"
      variant="secondary"
    >
      <VTabTriggerContainer>
        {periodUnitList.map(({ value, label }) => (
          <VTabTrigger key={value} value={value}>
            {label}
          </VTabTrigger>
        ))}
      </VTabTriggerContainer>
    </VTab>
  );
};
